<template>
    <div class="discountCode frame">
        <h3>{{'components/sidebar/discount-code.title' | trans}}</h3>
        <div class="inputWrap">
            <input type="text" placeholder="Discount Code">
            <button class="plus"><img src="/assets/img/plus.svg"></button>
        </div>
    </div>

</template>

<script>
    export default {

    }
</script>
